import { defineComponent as _defineComponent } from 'vue'
import { Event } from '@/models/Event';
import { EventOrganizer } from '@/models/EventOrganizer';
import EventOrganizerSelect from '@/components/event/EventOrganizerSelect.vue';
import { fieldRuleValue } from '@/helpers/tools';


export default /*#__PURE__*/_defineComponent({
  __name: 'EventOrganizerSelection',
  props: {
    record: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {




const eoMandatory = fieldRuleValue('field_rules.mandatory.event.organizer_id', false);

function onEventOrganizerSelect(eoRec: EventOrganizer | null) {
    if (eoRec) {
        emit('input', eoRec.id);
    } else {
        emit('input', null);
    }
}

return { __sfc: true,emit, eoMandatory, onEventOrganizerSelect, EventOrganizerSelect }
}

})